/**
 * The contract's vocabularies in the words the screens say them, once: the kinds a box can be (and the choices a
 * kind list offers), and the readers' lanes. A kind or a lane the schema adds is a compile error here, never a
 * missing choice or a raw key on a screen; the walk, the held tray, the Questions cards and the rule screen read
 * these and keep no table of their own.
 */
import type { components } from './types/api';

/** A kind a box can be, as the generated contract spells it. */
export type LayoutKind = components['schemas']['BoxDrawn']['kind'];

/** A reader's lane, as the generated contract spells it. */
export type ReaderLane = components['schemas']['ReaderLane'];

/** Every kind a box can be, written out so a kind the schema adds is a compile error here and not a missing choice. */
const KINDS = {
  ARTICLE_HEAD: true,
  PART_HEAD: true,
  SECTION_HEAD: true,
  SUBSECTION_HEAD: true,
  LIST_ITEM: true,
  EXCEPTION: true,
  INFORMATIONAL_NOTE: true,
  DEFINITION: true,
  TABLE: true,
  TABLE_CELL: true,
  CAPTION: true,
  FOOTNOTE: true,
  ITALIC_FOOTNOTE: true,
  FIGURE: true,
  BLOCK_TEXT: true,
  PARAGRAPH: true,
  RUNNING_HEAD: true,
  PAGE_NUMBER: true,
} as const satisfies Record<LayoutKind, true>;

/** A kind as the screens say it: lower case, words apart ("informational note"). */
export function kindWords(kind: string): string {
  return kind.toLowerCase().replaceAll('_', ' ');
}

/** The kinds a box can be, each with its words, in the schema's order. */
export const KIND_CHOICES: readonly { key: LayoutKind; label: string }[] = (Object.keys(KINDS) as LayoutKind[]).map((key) => ({
  key,
  label: kindWords(key),
}));

/** The words a reader's lane goes by, on a chip, in a tray row, on a card and in a sentence. */
export const LANE_WORDS: Record<ReaderLane, string> = {
  tesseract: 'Tesseract',
  vision: 'Apple Vision',
  'document-ai': 'Document AI',
  person: 'the reference',
  digital: 'Digital text',
};
